<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCommercialDashboardStore } from '@/stores/useCommercialDashboardStore'

const store = useCommercialDashboardStore()
const { syncResult, syncError } = storeToRefs(store)
</script>

<template>
  <div v-if="syncError" class="alert alert-error">
    <span class="text-sm">{{ syncError }}</span>
    <button class="btn btn-xs btn-ghost ml-auto" @click="syncError = null">✕</button>
  </div>
  <div v-else-if="syncResult" class="alert alert-success py-2.5">
    <span class="text-sm">
      ✓ Sync terminée —
      <strong>{{ syncResult.assignmentsCreated }} créés</strong>,
      {{ syncResult.assignmentsUpdated }} mis à jour
      <template v-if="syncResult.companiesImported > 0">
        · {{ syncResult.companiesImported }} sociétés importées
      </template>
      <template v-if="syncResult.invoicesCreated > 0 || syncResult.invoicesUpdated > 0">
        · {{ syncResult.invoicesCreated + syncResult.invoicesUpdated }} factures
      </template>
      <template v-if="syncResult.missingCompany > 0">
        · <span class="opacity-70">{{ syncResult.missingCompany }} introuvables sur Odoo</span>
      </template>
      <template v-if="syncResult.errors.length > 0">
        · <span class="text-error font-semibold">{{ syncResult.errors.length }} erreurs</span>
      </template>
    </span>
    <button class="btn btn-xs btn-ghost ml-auto" @click="syncResult = null">✕</button>
  </div>
</template>
